var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Statistique } from '../statistique/Statistique';
import { FiltreStatistique } from '../statistique/FiltreStatistique';
import { useState } from 'react';
import { Chip, Grid, Stack } from '@mui/material';
import { AgendaIcon } from '../../utils/Icons';
import { Modal } from '../../utils/Modal';
import { converYearMonthToString } from '../../services/dashboard';
import { Button } from '../../utils/Button';
import { getParamsDashboard, updateParamsDashboard, } from '../../services/filtre';
export var Dashboard = function () {
    var _a = useState(getParamsDashboard()), search = _a[0], setSearch = _a[1];
    var _b = useState(false), modalPeriode = _b[0], setModalPeriode = _b[1];
    var savePeriode = function (newSearch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            updateParamsDashboard(newSearch);
            setModalPeriode(false);
            setSearch(newSearch);
            return [2 /*return*/];
        });
    }); };
    var Titre = "P\u00E9riode de ".concat(converYearMonthToString(search.Debut));
    if (search.Debut !== search.Fin) {
        Titre += " \u00E0 ".concat(converYearMonthToString(search.Fin));
    }
    return (_jsxs(_Fragment, { children: [_jsxs(Grid, __assign({ container: true, padding: 2, spacing: 2 }, { children: [_jsx(Grid, { item: true, xs: 12, md: 2 }), _jsx(Grid, __assign({ item: true, xs: 12, md: 8 }, { children: _jsx(Stack, __assign({ alignItems: "center" }, { children: _jsx(Chip, { sx: {
                                    backgroundColor: 'header.main',
                                    color: 'white.main',
                                }, label: Titre }) })) })), _jsx(Grid, __assign({ item: true, xs: 12, md: 2, className: "p-none" }, { children: _jsx(Stack, __assign({ justifyContent: "end", alignItems: "end", className: "h-full" }, { children: _jsx(Button, __assign({ startIcon: _jsx(AgendaIcon, {}), color: "primary", onClick: function () { return setModalPeriode(true); } }, { children: "Changer la p\u00E9riode" })) })) })), _jsx(Grid, __assign({ item: true, xs: 12, md: 3 }, { children: _jsxs(Stack, __assign({ spacing: 2 }, { children: [_jsx(Statistique, __assign({ Display: "DerniersClients" }, search)), _jsx(Statistique, __assign({ Display: "ProchainesActivites" }, search))] })) })), _jsx(Grid, __assign({ item: true, xs: 12, md: 7 }, { children: _jsx(Statistique, __assign({ Display: "Synthese" }, search)) })), _jsx(Grid, __assign({ item: true, xs: 12, md: 2 }, { children: _jsxs(Stack, __assign({ spacing: 2 }, { children: [_jsx(Statistique, __assign({ Display: "Forecast" }, search)), _jsx(Statistique, __assign({ Display: "Compteurs" }, search))] })) }))] })), modalPeriode && (_jsx(Modal, __assign({ handleCloseModal: function () { return setModalPeriode(false); }, forceOpen: true, title: "Gestion du dashboard" }, { children: _jsx(Stack, __assign({ alignItems: "center" }, { children: _jsx(FiltreStatistique, { handeOnSearch: savePeriode, Search: search }) })) })))] }));
};
//# sourceMappingURL=Dashboard.js.map